import React from "react";
import { Box, Button, IconButton } from "@mui/material";
import { Save as SaveIcon, Delete as DeleteIcon } from "@mui/icons-material";

interface CreateShipmentRowProps {
  tempId: string;
  onSave: (tempId: string) => void;
  onDiscard: (tempId: string) => void;
}

export function CreateShipmentRowActions({
  tempId,
  onSave,
  onDiscard,
}: CreateShipmentRowProps) {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      <Button
        size="small"
        variant="outlined"
        color="primary"
        onMouseDown={(e) => {
          e.stopPropagation();
          e.preventDefault(); // Prevent focus change
          onSave(tempId);
        }}
        sx={{
          minWidth: "32px",
          width: "32px",
          height: "32px",
          padding: 0,
          borderRadius: 1,
          backgroundColor: "white",
        }}
      >
        <SaveIcon sx={{ fontSize: 16 }} />
      </Button>
      <Button
        size="small"
        variant="outlined"
        color="error"
        onMouseDown={(e) => {
          e.stopPropagation();
          e.preventDefault(); // Prevent focus change
          onDiscard(tempId);
        }}
        sx={{
          minWidth: "32px",
          width: "32px",
          height: "32px",
          padding: 0,
          borderRadius: 1,
          backgroundColor: "white",
        }}
      >
        <DeleteIcon sx={{ fontSize: 16 }} />
      </Button>
    </Box>
  );
}
